import React from 'react';

/**
 * 整行可点进详情 (与数据资产列表一致, 2026-09-12): 行内自带的链接 / 按钮 / 勾选框等交互元素
 * 自己处理点击, 不触发行跳转; 其余区域点击即进详情, 不必非得点「详情」两个字.
 */
export function rowClick(go: () => void) {
    return (e: React.MouseEvent<HTMLElement>) => {
        const t = e.target as HTMLElement | null;
        if (
            t &&
            t.closest(
                'a,button,input,label,select,textarea,summary,[role=switch]',
            )
        )
            return;
        go();
    };
}
